import { render, staticRenderFns } from "./AppBarDocs.vue?vue&type=template&id=86049154"
import script from "./AppBarDocs.vue?vue&type=script&lang=js"
export * from "./AppBarDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports